<div class="row">
  <div class="col-md-12 text-center">
    <p>
      Ingrese al chat con su cuenta favorita
    </p>
    <button type="button" class="btn btn-outline-primary ms-2" (click)="ingresar('google')">
      Google
    </button>
    <button type="button" class="btn btn-outline-info ms-2" (click)="ingresar('twitter')">
      Twitter
    </button>
  </div>
</div>
